import get from 'lodash.get';
import CryptoJS from 'crypto-js'
import { passwordReg } from '@/utils/regular'
// import { menus } from '@/menus';
// import Vue from 'vue';
// import bus from '@/utils/bus'
// import store from '@/store'
// import router from '@/router'


export function timeDate(value, fmt) {
  if (!value) {
    return value
  }
  if (!fmt) {
    fmt = 'yyyy-MM-dd hh:mm:ss'
  };
  let isSafariBrowser = () => {
    const ua = navigator.userAgent;
    const isSafariBrowser = /Safari\/([\d.]+)/.test(ua) && !/Chrome\/([\d.]+)/.test(ua);
    return isSafariBrowser
  }
  if (!(value instanceof Date)) {
    // // safari 仅支持 年/月/日 格式，不支持 年-月-日 
    value = isSafariBrowser() ? value && value.replace(/T/g, ' ').replace(/-/g, '/') : value
    value = new Date(value);
  }
  var o = {
    "M+": value.getMonth() + 1, //月份 
    "d+": value.getDate(), //日 
    "h+": value.getHours(), //小时 
    "m+": value.getMinutes(), //分 
    "s+": value.getSeconds(), //秒 
    "q+": Math.floor((value.getMonth() + 3) / 3), //季度 
    "S": value.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (value.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

//格式化金额
export function numberFormat(number, decimals = 2, dec_point = '.', thousands_sep = ',') {
  if (!number && number !== 0) return ""
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),//获取保留小数点后几位
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + n.toFixed(prec);
    };
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + thousands_sep + "$2");
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec_point);
}

/**
 * 深克隆
 * 
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}


export function getnull(object, path, defaultValue) {
  return get(object, path, defaultValue)
}

/* 页面内跳转页面 */
export function jumpPage(name, title, path, data) {
  // if (!data) data = {};
  // let index = 0;
  // menus.forEach((item, i) => {
  //   console.log(item.funcCode);
  //   if (item.funcCode == name) {
  //     index = i;
  //   }
  // })
  // bus.$emit('paths', index.toString(), path);
  // // store.commit('TABS', { title, path, index });
  // router.push({ path: path, query: data });
}


export function resetSize(vm) {
  var img_width, img_height, bar_width, bar_height	// 图片的宽度、高度，移动条的宽度、高度

  var parentWidth = vm.$el.parentNode.offsetWidth || window.offsetWidth
  var parentHeight = vm.$el.parentNode.offsetHeight || window.offsetHeight

  if (vm.imgSize.width.indexOf('%') != -1) {
    img_width = parseInt(this.imgSize.width) / 100 * parentWidth + 'px'
  } else {
    img_width = this.imgSize.width
  }

  if (vm.imgSize.height.indexOf('%') != -1) {
    img_height = parseInt(this.imgSize.height) / 100 * parentHeight + 'px'
  } else {
    img_height = this.imgSize.height
  }

  if (vm.barSize.width.indexOf('%') != -1) {
    bar_width = parseInt(this.barSize.width) / 100 * parentWidth + 'px'
  } else {
    bar_width = this.barSize.width
  }

  if (vm.barSize.height.indexOf('%') != -1) {
    bar_height = parseInt(this.barSize.height) / 100 * parentHeight + 'px'
  } else {
    bar_height = this.barSize.height
  }

  return { imgWidth: img_width, imgHeight: img_height, barWidth: bar_width, barHeight: bar_height }
}

export const _code_chars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
export const _code_color1 = ['#fffff0', '#f0ffff', '#f0fff0', '#fff0f0']
export const _code_color2 = ['#FF0033', '#006699', '#993366', '#FF9900', '#66CC66', '#FF33CC']


/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 *  */
export function aesEncrypt(word, keyWord = 'XwKsGlMcdPMEhR1B') {
  var key = CryptoJS.enc.Utf8.parse(keyWord)
  var srcs = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}

/**
 * 生成[min, max]随机数
 *
 * @param min 最小值（包含）
 * @param max 最大值（包含）
 * @returns {number} 随机数
 */
export function rand(min, max) { return Math.floor(Math.random() * (max - min + 1) + min) }

/**
 * 生成位数为[min, max]随机的，包含特殊字符的字符串
 *
 * @param minLen 最小长度（包含）
 * @param maxLen 最大长度（包含）
 * @returns {string} 随机字符串
 */
export function randPassword(minLen = 8, maxLen = 8) {
  const pwdRandomChar = ['abcdefghjkmnpqrstuvwxyz', 'ABCDEFGHJKMNPQRSTUVWXYZ', '23456789', '@#$%&']
  let pw = ''
  const len = rand(minLen, maxLen)
  const randSpecNum = rand(0, len - 1)
  for (let i = 0; i < len; i++) {
    let typeStr
    if (randSpecNum === i) {
      typeStr = pwdRandomChar[3]
    } else {
      typeStr = pwdRandomChar[rand(0, 2)]
    }
    pw += typeStr.charAt(rand(0, typeStr.length - 1))
  }

  return passwordReg(pw) ? pw : randPassword()
}

/*
*@description:'扁平化数组'
*@params1: treeList
*@params2: 参数2
*@ReturnValue:key 子集数组
*/
export function treeTraversal(treeList = [], key = "children") {
  let list = [];
  const loop = (tree) => {
    tree.map((item) => {
      const childrenList = item[key] ? item[key] : "";
      if (item.permissionType != 2) {//过滤掉非menu的 数据
        list = [...list, item];
      }
      return childrenList ? loop(childrenList) : "";
    });
  };
  loop(treeList);
  return list;
}
